import React from "react";
import Modal from "react-modal";
import "./Modal.css";
import "./ConfirmationModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Input from "../Input";

export default class ConfirmationModal extends React.Component<
  {
    show: boolean;
    title: string;
    msg: string;
    handleClose: any;
    handleConfirm: any;
    // optional partial-amount inputs - the euro and the percent field are two
    // views of the same value, the parent keeps them in sync
    amountValue?: number | string;
    onAmountChange?: any;
    amountMax?: number;
    percentValue?: number | string;
    onPercentChange?: any;
  },
  {}
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Modal
          isOpen={this.props.show}
          contentLabel="confirm"
          onRequestClose={() => {}}
          className="modal-size modal-background"
          ariaHideApp={false}
        >
          <div className="confirm-modal-inner">
            <div
              className="modal-cross-container"
              onClick={this.props.handleClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </div>
            <div className="modal-title-container">
              <span className="modal-title">{this.props.title}</span>
            </div>
            <span>{this.props.msg}</span>
            {this.props.onAmountChange && (
              <div className="modal-amount-container">
                <div className="modal-amount-field">
                  <span className="modal-amount-label">Betrag in Euro</span>
                  <Input
                    value={this.props.amountValue!}
                    onChange={this.props.onAmountChange}
                    placeholder="z. B. 35.00"
                    type="number"
                    min={0}
                    max={this.props.amountMax}
                    step={0.01}
                  />
                </div>
                {this.props.onPercentChange && !!this.props.amountMax && (
                  <div className="modal-amount-field">
                    <span className="modal-amount-label">Prozent</span>
                    <Input
                      value={this.props.percentValue!}
                      onChange={this.props.onPercentChange}
                      placeholder="z. B. 70"
                      type="number"
                      min={0}
                      max={100}
                      step={0.01}
                    />
                  </div>
                )}
              </div>
            )}
            <div className="modal-btn-container">
              <button
                className={"modal-btn"}
                onClick={() => {
                  this.props.handleConfirm();
                }}
              >
                Ja
              </button>
              <button
                className={"modal-btn modal-btn-red"}
                onClick={() => {
                  this.props.handleClose();
                }}
              >
                Nein
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
